webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HomePage__ = __webpack_require__(12);
//
//
//
//
//
//
//
//




var socialData = __webpack_require__(175);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__["a" /* default */],
    HomePage: __WEBPACK_IMPORTED_MODULE_1__components_HomePage__["a" /* default */]
  },
  data: function data() {
    return {
      social: socialData
    };
  }
});

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_brands__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_pro_light__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppHeader',
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default.a
  },
  methods: {
    faIconFromName: function faIconFromName(icon) {
      switch (icon) {
        case 'coffee':
          return __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_pro_light__["b" /* faCoffee */];
        case 'twitter':
          return __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_brands__["h" /* faTwitter */];
        case 'instagram':
          return __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_brands__["e" /* faInstagram */];
        case 'pinterest':
          return __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_brands__["g" /* faPinterest */];
        case 'github':
          return __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_brands__["c" /* faGithub */];
        case 'facebook':
          return __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_brands__["a" /* faFacebook */];
        case 'linkedin':
          return __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_brands__["f" /* faLinkedinIn */];
        case 'flickr':
          return __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_brands__["b" /* faFlickr */];
        case 'gplus':
          return __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_brands__["d" /* faGooglePlusG */];
        default:
          return __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_pro_light__["b" /* faCoffee */];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    social: {
      type: Array,
      required: false
    }
  }
});

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cdfb502_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__ = __webpack_require__(174);
function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cdfb502"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cdfb502_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PostCard__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomePage',
  components: {
    PostCard: __WEBPACK_IMPORTED_MODULE_1__components_PostCard__["a" /* default */]
  },
  data: function data() {
    return {
      posts: []
    };
  },
  created: function created() {
    var self = this;
    var apiBase = this.apiBaseUrl;
    // eslint-disable-next-line no-console
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiBase + 'wp/v2/posts?categories_exclude=3').then(function (response) {
      // JSON responses are automatically parsed.
      // eslint-disable-next-line no-console
      console.log(response.data);
      var apiPost = null;
      for (var p = 0; p < response.data.length; p += 1) {
        apiPost = response.data[p];
        self.posts.push({
          id: apiPost.id,
          title: apiPost.title.rendered,
          tags: [],
          intro: apiPost.excerpt.rendered,
          // img: apiPost._embedded["wp:featuredmedia"][0].source_url
          link: apiPost.link
        });
      }

      // eslint-disable-next-line no-console
      console.log(self.posts);
      // this.posts = response.data
    }).catch(function (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    });
  },

  methods: {
    postSizeClass: function postSizeClass(post) {
      if ('img' in post) {
        return 'col-md-8';
      }
      return 'col-md-4';
    }
  }
});

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PostCard__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CategoryIndex',
  components: {
    PostCard: __WEBPACK_IMPORTED_MODULE_1__components_PostCard__["a" /* default */]
  },
  props: {
    categorySlug: {
      type: String,
      required: true
    },
    page: {
      type: Number,
      required: false,
      default: 1
    }
  },
  data: function data() {
    return {
      posts: [],
      category: null,
      loading: true
    };
  },

  watch: {
    // whenever question changes, this function will run
    category: function category(newCategory) {
      this.posts = [];
      this.loading = true;
      this.setPostsFromCategory(newCategory.id);
    }
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.setCategoryBySlug(to.params.categorySlug);
    next();
  },
  created: function created() {
    this.setCategoryBySlug(this.categorySlug);
    // Note: this.category is watched to subsequently update posts.
  },

  methods: {
    postSizeClass: function postSizeClass(post) {
      if ('img' in post) {
        return 'col-md-8';
      }
      return 'col-md-4';
    },
    setCategoryBySlug: function setCategoryBySlug(categorySlug) {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(self.apiBaseUrl + 'wp/v2/categories?slug=' + categorySlug).then(function (response) {
        self.category = response.data[0]; // Assume the first and only category
      }).catch(function (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      });
    },
    setPostsFromCategory: function setPostsFromCategory(categoryId) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(self.apiBaseUrl + 'wp/v2/posts?categories=' + categoryId).then(function (response) {
        var apiPost = null;
        var posts = [];
        for (var p = 0; p < response.data.length; p += 1) {
          apiPost = response.data[p];
          posts.push({
            id: apiPost.id,
            title: apiPost.title.rendered,
            tags: [],
            intro: apiPost.excerpt.rendered,
            // img: apiPost._embedded["wp:featuredmedia"][0].source_url
            link: apiPost.link
          });
        }
        self.posts = posts;
        // callback(posts);
      }).catch(function (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        return [];
      });
    },
    setPosts: function setPosts(posts) {
      // eslint-disable-next-line no-console
      console.log('Setting posts...');
      this.posts = posts;
    },
    setCategory: function setCategory(category) {
      this.category = category;
    }
  }
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_pro_light__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(177);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__["default"].library.add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_pro_light__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      get appBaseUrl() {
        var appRefHref = document.querySelector('link[rel="app.developerjack.com"]');

        /* eslint-disable no-console */
        console.log(appRefHref);

        if (!appRefHref) {
          return 'https://app.developerjack.com/';
        }
        return appRefHref.getAttribute('href');
      },
      get apiBaseUrl() {
        var wpRelHref = document.querySelector('link[rel="https://api.w.org/"]');

        if (!wpRelHref) {
          return 'https://content.developerjack.com/wp-json/';
        }
        return wpRelHref.getAttribute('href');
      }
    };
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91d66124_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(176);
function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91d66124_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 146:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7108bb1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__(152);
function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7108bb1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 149:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('nav',{staticClass:"navbar",attrs:{"id":"navbar"}},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"},domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('ul',{attrs:{"id":"social"}},_vm._l((_vm.social),function(network){return _c('li',{key:network.name},[_c('a',{attrs:{"href":network.href,"title":network.name,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faIconFromName(network.name),"size":"lg"}})],1)])}))],1),_vm._v(" "),_c('div',{staticClass:"pride-strip",attrs:{"id":"rainbow"}}),_vm._v(" "),_c('div',{attrs:{"id":"menu"}},[_c('ul',{staticClass:"menu"},[_c('li',[_c('router-link',{staticClass:"menu-link",attrs:{"to":"/"}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"menu-link",attrs:{"to":"/blog"}},[_vm._v("Blog")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"menu-link",attrs:{"to":"/weekly"}},[_vm._v("The Weekly")])],1),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"menu-link",attrs:{"href":"#"}},[_vm._v("Press")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 153:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"card post-card  flex-md-row mb-4 box-shadow h-md-250"},[_c('img',{staticClass:"card-img-left flex-auto",attrs:{"if":_vm.post.img,"src":_vm.post.img}}),_vm._v(" "),_c('div',{staticClass:"card-body  card-body d-flex flex-column align-items-start"},[_c('h3',[_c('router-link',{attrs:{"to":{ path: _vm.path}}},[_vm._v(_vm._s(_vm.post.title))])],1),_vm._v(" "),_vm._l((_vm.post.tags),function(tag){return _c('span',{key:tag,staticClass:"tag"},[_vm._v(_vm._s(tag))])}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.post.intro)}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"homepage"}},[_c('div',{staticClass:"row"},_vm._l((_vm.posts),function(post){return _c('div',{key:post.id,staticClass:"post",class:_vm.postSizeClass(post)},[_c('post-card',{attrs:{"post":post}})],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

module.exports = [{"name":"twitter","href":"https://www.twitter.com/developerjack"},{"name":"linkedin","href":"https://www.linkedin.com/in/developerjack"},{"name":"instagram","href":"https://instagram.com/developerjack"},{"name":"github","href":"https://github.com/devjack"},{"name":"facebook","href":"https://www.facebook.com/profile.php?id=100011025072440"},{"name":"flickr","href":"https://www.flickr.com/photos/142140756@N03"},{"name":"gplus","href":"https://plus.google.com/111650013076489260266"}]

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header',{attrs:{"title":"Ramblings of an Engineer","social":_vm.social}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomePage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Post__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CategoryIndex__ = __webpack_require__(186);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomePage__["a" /* default */]
  }, {
    path: '/:categorySlug/',
    // @TODO: path param filtering (year/day etc)
    alias: [
      // '/:categorySlug/:year/:month/:day/', // Sculpin routes.
    ],
    name: 'CategoryIndex',
    component: __WEBPACK_IMPORTED_MODULE_4__components_CategoryIndex__["a" /* default */],
    props: true
  }, {
    path: '/:category/:slug', // WP+Hugo routes (The Weekly)
    alias: ['/:category/:year/:month/:day/:slug', // Sculpin routes.
    '/:category/:year/:slug'],
    name: 'Post',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Post__["a" /* default */],
    props: true
  }]
}));

// Paths:
// format: {category}/{year}/{month}/{day}/{slug} => /blog/2016/01/07/open-source-croudsourcing
// format: {category}/{year}/{slug} => /blog/2018/welcome-to-the-jungle
// format: {category}/{slug} => /weekly/12

// @TODO: WP will write /weekly/the-weekly-xx as the new slug.
// @TODO: Implement /weekly/:id => the-weekly-:id   as a rewrite...

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50cc9b00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__ = __webpack_require__(185);
function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50cc9b00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 180:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 22,
	"./af.js": 22,
	"./ar": 23,
	"./ar-dz": 24,
	"./ar-dz.js": 24,
	"./ar-kw": 25,
	"./ar-kw.js": 25,
	"./ar-ly": 26,
	"./ar-ly.js": 26,
	"./ar-ma": 27,
	"./ar-ma.js": 27,
	"./ar-sa": 28,
	"./ar-sa.js": 28,
	"./ar-tn": 29,
	"./ar-tn.js": 29,
	"./ar.js": 23,
	"./az": 30,
	"./az.js": 30,
	"./be": 31,
	"./be.js": 31,
	"./bg": 32,
	"./bg.js": 32,
	"./bm": 33,
	"./bm.js": 33,
	"./bn": 34,
	"./bn.js": 34,
	"./bo": 35,
	"./bo.js": 35,
	"./br": 36,
	"./br.js": 36,
	"./bs": 37,
	"./bs.js": 37,
	"./ca": 38,
	"./ca.js": 38,
	"./cs": 39,
	"./cs.js": 39,
	"./cv": 40,
	"./cv.js": 40,
	"./cy": 41,
	"./cy.js": 41,
	"./da": 42,
	"./da.js": 42,
	"./de": 43,
	"./de-at": 44,
	"./de-at.js": 44,
	"./de-ch": 45,
	"./de-ch.js": 45,
	"./de.js": 43,
	"./dv": 46,
	"./dv.js": 46,
	"./el": 47,
	"./el.js": 47,
	"./en-au": 48,
	"./en-au.js": 48,
	"./en-ca": 49,
	"./en-ca.js": 49,
	"./en-gb": 50,
	"./en-gb.js": 50,
	"./en-ie": 51,
	"./en-ie.js": 51,
	"./en-nz": 52,
	"./en-nz.js": 52,
	"./eo": 53,
	"./eo.js": 53,
	"./es": 54,
	"./es-do": 55,
	"./es-do.js": 55,
	"./es-us": 56,
	"./es-us.js": 56,
	"./es.js": 54,
	"./et": 57,
	"./et.js": 57,
	"./eu": 58,
	"./eu.js": 58,
	"./fa": 59,
	"./fa.js": 59,
	"./fi": 60,
	"./fi.js": 60,
	"./fo": 61,
	"./fo.js": 61,
	"./fr": 62,
	"./fr-ca": 63,
	"./fr-ca.js": 63,
	"./fr-ch": 64,
	"./fr-ch.js": 64,
	"./fr.js": 62,
	"./fy": 65,
	"./fy.js": 65,
	"./gd": 66,
	"./gd.js": 66,
	"./gl": 67,
	"./gl.js": 67,
	"./gom-latn": 68,
	"./gom-latn.js": 68,
	"./gu": 69,
	"./gu.js": 69,
	"./he": 70,
	"./he.js": 70,
	"./hi": 71,
	"./hi.js": 71,
	"./hr": 72,
	"./hr.js": 72,
	"./hu": 73,
	"./hu.js": 73,
	"./hy-am": 74,
	"./hy-am.js": 74,
	"./id": 75,
	"./id.js": 75,
	"./is": 76,
	"./is.js": 76,
	"./it": 77,
	"./it.js": 77,
	"./ja": 78,
	"./ja.js": 78,
	"./jv": 79,
	"./jv.js": 79,
	"./ka": 80,
	"./ka.js": 80,
	"./kk": 81,
	"./kk.js": 81,
	"./km": 82,
	"./km.js": 82,
	"./kn": 83,
	"./kn.js": 83,
	"./ko": 84,
	"./ko.js": 84,
	"./ky": 85,
	"./ky.js": 85,
	"./lb": 86,
	"./lb.js": 86,
	"./lo": 87,
	"./lo.js": 87,
	"./lt": 88,
	"./lt.js": 88,
	"./lv": 89,
	"./lv.js": 89,
	"./me": 90,
	"./me.js": 90,
	"./mi": 91,
	"./mi.js": 91,
	"./mk": 92,
	"./mk.js": 92,
	"./ml": 93,
	"./ml.js": 93,
	"./mr": 94,
	"./mr.js": 94,
	"./ms": 95,
	"./ms-my": 96,
	"./ms-my.js": 96,
	"./ms.js": 95,
	"./mt": 97,
	"./mt.js": 97,
	"./my": 98,
	"./my.js": 98,
	"./nb": 99,
	"./nb.js": 99,
	"./ne": 100,
	"./ne.js": 100,
	"./nl": 101,
	"./nl-be": 102,
	"./nl-be.js": 102,
	"./nl.js": 101,
	"./nn": 103,
	"./nn.js": 103,
	"./pa-in": 104,
	"./pa-in.js": 104,
	"./pl": 105,
	"./pl.js": 105,
	"./pt": 106,
	"./pt-br": 107,
	"./pt-br.js": 107,
	"./pt.js": 106,
	"./ro": 108,
	"./ro.js": 108,
	"./ru": 109,
	"./ru.js": 109,
	"./sd": 110,
	"./sd.js": 110,
	"./se": 111,
	"./se.js": 111,
	"./si": 112,
	"./si.js": 112,
	"./sk": 113,
	"./sk.js": 113,
	"./sl": 114,
	"./sl.js": 114,
	"./sq": 115,
	"./sq.js": 115,
	"./sr": 116,
	"./sr-cyrl": 117,
	"./sr-cyrl.js": 117,
	"./sr.js": 116,
	"./ss": 118,
	"./ss.js": 118,
	"./sv": 119,
	"./sv.js": 119,
	"./sw": 120,
	"./sw.js": 120,
	"./ta": 121,
	"./ta.js": 121,
	"./te": 122,
	"./te.js": 122,
	"./tet": 123,
	"./tet.js": 123,
	"./th": 124,
	"./th.js": 124,
	"./tl-ph": 125,
	"./tl-ph.js": 125,
	"./tlh": 126,
	"./tlh.js": 126,
	"./tr": 127,
	"./tr.js": 127,
	"./tzl": 128,
	"./tzl.js": 128,
	"./tzm": 129,
	"./tzm-latn": 130,
	"./tzm-latn.js": 130,
	"./tzm.js": 129,
	"./uk": 131,
	"./uk.js": 131,
	"./ur": 132,
	"./ur.js": 132,
	"./uz": 133,
	"./uz-latn": 134,
	"./uz-latn.js": 134,
	"./uz.js": 133,
	"./vi": 135,
	"./vi.js": 135,
	"./x-pseudo": 136,
	"./x-pseudo.js": 136,
	"./yo": 137,
	"./yo.js": 137,
	"./zh-cn": 138,
	"./zh-cn.js": 138,
	"./zh-hk": 139,
	"./zh-hk.js": 139,
	"./zh-tw": 140,
	"./zh-tw.js": 140
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 182;

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"post"}},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-10 col-"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("\n        Loading...\n      ")]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.error)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.post)?_c('article',{staticClass:"content"},[_c('header',[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.post.title.rendered)}}),_vm._v(" "),_c('ul',[_c('li',{domProps:{"innerHTML":_vm._s(_vm.displayDate)}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.readingTime)}})])]),_vm._v(" "),_c('main',{domProps:{"innerHTML":_vm._s(_vm.post.content.rendered)}})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryIndex_vue__ = __webpack_require__(141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a396c43e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryIndex_vue__ = __webpack_require__(188);
function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a396c43e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a396c43e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 187:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"category-index"}},[_c('div',{staticClass:"row"},[(_vm.category)?_c('div',{staticClass:"col-md-12"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.category.title)}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((this.posts),function(post){return _c('div',{key:post.id,staticClass:"post",class:_vm.postSizeClass(post)},[_c('post-card',{attrs:{"post":post}})],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostCard_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403f0618_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostCard_vue__ = __webpack_require__(173);
function injectStyle (ssrContext) {
  __webpack_require__(172)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-403f0618"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403f0618_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PostCard',
  props: {
    post: {
      title: {
        type: String,
        required: true
      },
      link: {
        type: String,
        required: true
      },
      tags: {
        type: Array,
        required: true
      },
      intro: {
        type: String,
        required: true
      },
      img: {
        type: String,
        required: false
      }
    }
  },
  computed: {
    path: function path() {
      var url = new URL(this.post.link);
      return url.pathname;
    }
  }
});

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reading_time__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reading_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reading_time__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Post',
  props: ['slug'],
  data: function data() {
    return {
      loading: false,
      post: null,
      error: null
    };
  },

  computed: {
    displayDate: function displayDate() {
      if (!this.post) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('D MMMM YYYY');
    },
    readingTime: function readingTime() {
      if (!this.post) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_2_reading_time___default()(this.post.content.rendered).text;
    }
  },
  created: function created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },

  watch: {
    // call again the method if the route changes
    $route: 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var self = this;
      this.error = null;
      this.post = null;
      this.loading = true;

      // eslint-disable-next-line no-unused-vars
      var slug = this.slug;
      // TODO: This assumes no posts of the same slug in different categories.
      // In the event of two duplicate slugs in different categories,
      //   the post shown is undefined (using the first result from the API impl.)
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(self.apiBaseUrl + 'wp/v2/posts?slug=' + slug).then(function (response) {
        _this.loading = false;
        if (response.data.length === 0) {
          _this.error = '404 post not found';
        } else if (response.data.length > 1) {
          _this.error = '400 Slugs galore!';
          // eslint-disable-next-line no-console
          console.log('Slugs galore! Jack promised himself this would never happen!');
        } else {
          // For the 1x post that is returned...
          _this.post = response.data[0];
        }
      }).catch(function (e) {
        _this.error = true;
        // eslint-disable-next-line no-console
        console.log(e);
      });
    }
  }
});

/***/ })

},[142]);


// WEBPACK FOOTER //
// static/js/app.js